const HAVEN_MENTION_PATTERN = new RegExp(
  '(?:^|[^\\p{L}\\p{N}_@])@haven(?![\\p{L}\\p{N}_]|\\.[\\p{L}\\p{N}])',
  'iu'
)

export const addressesHaven = (message: string): boolean =>
  HAVEN_MENTION_PATTERN.test(message)
